(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-link-preview"] && !Shopify.designMode) return;
  try {
    (()=>{const e=window.matchMedia("(hover: hover) and (pointer: fine) and (min-width: 990px)"),t=document.querySelector("[data-re-product-peek]");if(!t)return;const n=new Map,r=new WeakSet,a=t.querySelector("[data-re-peek-image]"),o=t.querySelector("[data-re-peek-url]"),i=t.querySelector("[data-re-peek-title]"),d=t.querySelector("[data-re-peek-price]"),c=t.querySelector("[data-re-peek-action]"),s=t.dataset,u=new Intl.NumberFormat(document.documentElement.lang||"en-GB",{style:"currency",currency:s.currency||"GBP"});let l=null,w=null,h=null,m=null,p=0;const b=e=>{const t=new URL(e,window.location.origin);return t.origin!==window.location.origin?null:t.pathname.includes("/products/")?(t.search="",t.hash="",t):null},f=async(e,t)=>{t.disabled=!0,t.setAttribute("aria-busy","true");try{const n=await fetch(window.routes.cart_add_url,{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:[{id:e,quantity:1}],sections:["cart-drawer","cart-icon-bubble"],sections_url:window.location.pathname})}),r=await n.json();if(!n.ok||r.status)throw new Error("Cart error");t.textContent=s.addedLabel;const a=document.querySelector("cart-drawer");window.reCartDrawer&&"function"==typeof window.reCartDrawer.refresh?await window.reCartDrawer.refresh(!0):a&&"function"==typeof a.renderContents?a.renderContents(r):(e=>{if(!e)return;const t=(new DOMParser).parseFromString(e,"text/html").querySelector("#cart-icon-bubble"),n=document.querySelector("#cart-icon-bubble");t&&n&&(n.innerHTML=t.innerHTML)})(r.sections&&r.sections["cart-icon-bubble"]),window.setTimeout(()=>{t.textContent=s.addLabel,t.disabled=!1,t.removeAttribute("aria-busy")},1600)}catch(e){t.textContent=s.errorLabel,t.disabled=!1,t.removeAttribute("aria-busy")}},y=(e,t)=>{const n=Array.isArray(e.variants)?e.variants:[],r=n.find(e=>e.available),l=n.length>1,w=e.featured_image||e.images&&e.images[0];if(i.textContent=e.title,i.href=t.toString(),o.href=t.toString(),a.src=(e=>{if(!e)return"";const t=new URL(e,window.location.origin);return t.searchParams.set("width","240"),t.toString()})(w),a.alt=e.title,a.hidden=!w,d.textContent=u.format(Number(e.price||0)/100),c.replaceChildren(),l&&r)return void c.append((e=>{const t=document.createElement("a");return t.className="re-product-peek__button",t.href=e.toString(),t.textContent=s.chooseLabel,t})(t));const h=(e=>{const t=document.createElement("button");return t.type="button",t.className="re-product-peek__button",t.textContent=e,t})(r?s.addLabel:s.soldOutLabel);h.disabled=!r,r&&h.addEventListener("click",()=>f(r.id,h)),c.append(h)},v=()=>{if(!l||t.hidden)return;const e=l.getBoundingClientRect(),n=t.getBoundingClientRect();let r=e.bottom+10,a=e.left+e.width/2-n.width/2;r+n.height>window.innerHeight-16&&(r=e.top-n.height-10),r=Math.max(16,Math.min(r,window.innerHeight-n.height-16)),a=Math.max(16,Math.min(a,window.innerWidth-n.width-16)),t.style.top=`${Math.round(r)}px`,t.style.left=`${Math.round(a)}px`},g=(e=!1)=>{window.clearTimeout(w),window.clearTimeout(h),window.clearTimeout(m),l&&l.setAttribute("aria-expanded","false"),t.classList.remove("is-open");const n=()=>{t.hidden=!0,l=null};e?n():m=window.setTimeout(n,140)},L=()=>{window.clearTimeout(h),h=window.setTimeout(()=>{t.matches(":hover")||t.contains(document.activeElement)||g()},180)},E=async r=>{if(!e.matches)return;const a=b(r.href);if(!a)return;window.clearTimeout(h),window.clearTimeout(m),l=r;const o=++p;try{const e=await(async e=>{const t=(e=>`${e.pathname.replace(/\/$/,"")}.js`)(e);return n.has(t)||n.set(t,fetch(t,{headers:{Accept:"application/json"}}).then(e=>{if(!e.ok)throw new Error("Product unavailable");return e.json()}).catch(e=>{throw n.delete(t),e})),n.get(t)})(a);if(o!==p||l!==r)return;y(e,a),t.hidden=!1,r.setAttribute("aria-expanded","true"),v(),window.requestAnimationFrame(()=>t.classList.add("is-open"))}catch(e){g(!0)}},C=e=>{window.clearTimeout(w),window.clearTimeout(h),w=window.setTimeout(()=>E(e),250)},S=()=>{document.querySelectorAll('#MainContent .rte a[href*="/products/"], #MainContent .product__description a[href*="/products/"], #MainContent .article-template__content a[href*="/products/"]').forEach(e=>{r.has(e)||b(e.href)&&(r.add(e),e.setAttribute("aria-controls",t.id),e.setAttribute("aria-expanded","false"),e.addEventListener("mouseenter",()=>C(e)),e.addEventListener("mouseleave",L),e.addEventListener("focus",()=>C(e)),e.addEventListener("blur",L))})};t.addEventListener("mouseenter",()=>window.clearTimeout(h)),t.addEventListener("mouseleave",L),t.addEventListener("focusin",()=>window.clearTimeout(h)),t.addEventListener("focusout",L),document.addEventListener("keydown",e=>{if("Escape"!==e.key||t.hidden)return;const n=l;g(!0),n&&n.focus()}),document.addEventListener("click",e=>{t.hidden||t.contains(e.target)||e.target===l||g()}),window.addEventListener("resize",v),window.addEventListener("scroll",v,{passive:!0}),document.addEventListener("shopify:section:load",S),e.addEventListener("change",e=>{e.matches||g(!0)}),S()})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["re-cart-drawer-base"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.reCartDrawerInitialized) return;
  window.reCartDrawerInitialized = true;

  const drawer = document.querySelector('[data-re-cartdrawer]');
  if (!drawer) return;

  document.body.appendChild(drawer);

  const bodyEl = drawer.querySelector('[data-re-cartdrawer-body]');
  const footEl = drawer.querySelector('[data-re-cartdrawer-foot]');
  const subtotalEl = drawer.querySelector('[data-re-cartdrawer-subtotal]');
  const titleEl = drawer.querySelector('[data-re-cartdrawer-title]');

  const FREE_SHIPPING_THRESHOLD = 7000;
  const POST_OFFICE_WEIGHT_LIMIT = 1900;

  const freeShipText = drawer.querySelector('[data-re-cartdrawer-free-ship-text]');
  const freeShipBar = drawer.querySelector('[data-re-cartdrawer-progress]');
  const postOfficeBox = drawer.querySelector('[data-re-cartdrawer-postoffice]');
  const postOfficeText = drawer.querySelector('[data-re-cartdrawer-postoffice-text]');

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;

    const currency =
  window.Shopify?.currency?.active ||
  drawer.dataset.currency ||
  'GBP';

return new Intl.NumberFormat(drawer.dataset.locale || 'en-GB', {
      style: 'currency',
      currency
    }).format(amount);
  }

  function setDrawerBarPct(pct){
    if (!freeShipBar) return;
    freeShipBar.style.setProperty('--pct', String(pct));
  }

  function updateFreeShipping(cart){
    if (!freeShipText || !freeShipBar || !cart) return;

    const total = Number(cart.total_price || 0);
    const remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - total);

    let pct = Math.floor((total * 100) / FREE_SHIPPING_THRESHOLD);
    pct = Math.max(0, Math.min(100, pct));

    if (total > 0 && pct < 3) pct = 3;

    freeShipText.textContent =
      remaining > 0
        ? `Almost there — spend ${formatMoney(remaining)} more.`
        : 'Qualified ✓';

    requestAnimationFrame(() => setDrawerBarPct(pct));
  }

function updatePostOffice(cart){
  if (!postOfficeBox || !postOfficeText || !cart) return;

  const visibleItems = cart?.items?.filter(item => Number(item.quantity) > 0) || [];

  const totalWeight = visibleItems.reduce((sum, item) => {
    return sum + ((Number(item.grams) || 0) * Number(item.quantity || 0));
  }, 0);

  if (totalWeight <= 0 || totalWeight >= POST_OFFICE_WEIGHT_LIMIT) {
    postOfficeBox.hidden = true;
    return;
  }

  const remainingWeight = POST_OFFICE_WEIGHT_LIMIT - totalWeight;
  const roundedRemaining = Math.max(50, Math.round(remainingWeight / 50) * 50);

  postOfficeText.textContent =
    `There's still room for approximately ${roundedRemaining}g of smaller items before a courier may be needed.`;

  postOfficeBox.hidden = false;
}

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add('re-cartdrawer-open');
    document.body.classList.add('re-cartdrawer-open');

    fetchCart().then((cart) => {
      renderCart(cart);
      syncCartCount(cart);
    }).catch(console.error);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('re-cartdrawer-open');
    document.body.classList.remove('re-cartdrawer-open');
  }

  function renderEmpty() {
    bodyEl.innerHTML = `
      <div class="re-cartdrawer__empty">
        <p>Your basket is currently empty.</p>
      </div>
    `;

    if (titleEl) titleEl.textContent = 'Your Basket (0)';
    footEl.hidden = true;
  }

  function renderCart(cart) {
    const visibleItems = cart?.items?.filter(item => Number(item.quantity) > 0) || [];

    if (!visibleItems.length) {
      renderEmpty();
      return;
    }

    const visibleCount = visibleItems.reduce((sum, item) => {
      return sum + Number(item.quantity || 0);
    }, 0);

    if (titleEl) titleEl.textContent = `Your Basket (${visibleCount})`;

    const itemsHtml = visibleItems.map((item) => {
      const line = cart.items.findIndex(cartItem => cartItem.key === item.key) + 1;
      const image = item.featured_image?.url || item.image || '';

      const variantText =
        item.variant_title &&
        item.variant_title !== 'Default Title'
          ? item.variant_title
          : '';

      const minusQty = Math.max(0, item.quantity - 1);

      return `
        <div class="re-cartdrawer__item" data-line-key="${escapeHtml(item.key)}">
          <div class="re-cartdrawer__media">
            ${image ? `<img class="re-cartdrawer__image" src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title)}">` : ''}
          </div>

          <div class="re-cartdrawer__content">
            <div class="re-cartdrawer__top">
              <p class="re-cartdrawer__item-title">
                <a href="${escapeHtml(item.url || '#')}">${escapeHtml(item.product_title)}</a>
              </p>

              <button
                type="button"
                class="re-cartdrawer__remove re-cartdrawer__remove--icon"
                data-re-cartdrawer-line="${line}"
                data-qty="0"
                aria-label="Remove item"
              >×</button>
            </div>

            ${variantText ? `<div class="re-cartdrawer__variant">${escapeHtml(variantText)}</div>` : ''}

            <div class="re-cartdrawer__bottom">
              <div class="re-cartdrawer__qty">
                <button
                  type="button"
                  class="re-cartdrawer__qty-btn"
                  data-re-cartdrawer-line="${line}"
                  data-qty="${minusQty}"
                >−</button>

                <input
                  class="re-cartdrawer__qty-input"
                  type="number"
                  min="0"
                  step="1"
                  inputmode="numeric"
                  value="${item.quantity}"
                  data-re-cartdrawer-line-input="${line}"
                >

                <button
                  type="button"
                  class="re-cartdrawer__qty-btn"
                  data-re-cartdrawer-line="${line}"
                  data-qty="${item.quantity + 1}"
                >+</button>
              </div>

              <div class="re-cartdrawer__pricewrap">
                ${item.original_line_price > item.final_line_price ? `<div class="re-cartdrawer__compare">RRP: <s>${formatMoney(item.original_line_price)}</s></div>` : ''}
                <div class="re-cartdrawer__price">${formatMoney(item.final_line_price)}</div>
              </div>
            </div>
          </div>
        </div>
      `;
    }).join('');

    bodyEl.innerHTML = itemsHtml;
    subtotalEl.textContent = formatMoney(cart.total_price);
    footEl.hidden = false;

    updateFreeShipping(cart);
    updatePostOffice(cart);
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });

    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  function syncCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  }

  async function refreshCartDrawer(openAfter = false) {
    try {
      const cart = await fetchCart();
      renderCart(cart);
      syncCartCount(cart);

      if (openAfter) openDrawer();
    } catch (e) {
      console.error(e);
    }
  }

  async function changeLineItem(line, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      });

      const data = await res.json();

      if (!res.ok) {
        await refreshCartDrawer(false);
        return;
      }

      renderCart(data);
      syncCartCount(data);
    } catch (e) {
      console.error(e);
      await refreshCartDrawer(false);
    }
  }

  drawer.addEventListener('click', (e) => {
    if (e.target.closest('[data-re-cartdrawer-close]')) {
      closeDrawer();
      return;
    }

    const qtyInput = e.target.closest('[data-re-cartdrawer-line-input]');
    if (qtyInput) {
      try {
        qtyInput.select();
      } catch (_) {}
      return;
    }

    const changeBtn = e.target.closest('[data-re-cartdrawer-line]');
    if (changeBtn) {
      const line = parseInt(changeBtn.getAttribute('data-re-cartdrawer-line'), 10);
      const qty = parseInt(changeBtn.getAttribute('data-qty'), 10);

      if (!Number.isFinite(line) || !Number.isFinite(qty)) return;
      changeLineItem(line, qty);
    }
  });

  drawer.addEventListener('focusin', (e) => {
    const qtyInput = e.target.closest('[data-re-cartdrawer-line-input]');
    if (!qtyInput) return;

    try {
      qtyInput.select();
    } catch (_) {}
  });

  drawer.addEventListener('input', (e) => {
    const qtyInput = e.target.closest('[data-re-cartdrawer-line-input]');
    if (!qtyInput) return;

    const raw = qtyInput.value.replace(/[^0-9]/g, '');

    if (raw === '') {
      qtyInput.value = '';
      return;
    }

    qtyInput.value = String(Math.max(0, parseInt(raw, 10) || 0));
  });

  drawer.addEventListener('change', async (e) => {
    const qtyInput = e.target.closest('[data-re-cartdrawer-line-input]');
    if (!qtyInput) return;

    const line = parseInt(qtyInput.getAttribute('data-re-cartdrawer-line-input'), 10);
    if (!Number.isFinite(line)) return;

    let qty = parseInt(qtyInput.value, 10);
    if (!Number.isFinite(qty)) qty = 1;
    if (qty < 0) qty = 0;

    await changeLineItem(line, qty);
  });

  document.addEventListener('click', (e) => {
    if (!drawer.classList.contains('is-open')) return;

    const panel = drawer.querySelector('.re-cartdrawer__panel');
    if (!panel) return;

    if (!panel.contains(e.target)) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  window.reCartDrawer = {
    open: () => openDrawer(),
    close: () => closeDrawer(),
    refresh: (openAfter = false) => refreshCartDrawer(openAfter)
  };
})();
  } catch(e) { console.error(e); }
})();

})();
